import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconRouterWhite({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path id="a" d="M0 0h21.74v17.531H0z" />
				<path id="c" d="M0 17.96h22V0H0z" />
			</defs>
			<g fill="none" fillRule="evenodd" transform="translate(1 3)">
				<path
					fill="#CD0400"
					d="M8.199 5.563a5.3 5.3 0 0 1 5.844 0 .271.271 0 1 0 .3-.452 5.85 5.85 0 0 0-6.444 0 .272.272 0 1 0 .3.452"
				/>
				<path
					fill="#CD0400"
					d="M13.318 6.89c.27 0 .374-.35.15-.497a4.29 4.29 0 0 0-4.693 0c-.303.198-.005.652.298.454a3.74 3.74 0 0 1 4.096 0 .27.27 0 0 0 .149.044M12.673 8.044a.27.27 0 0 0-.084-.374 2.75 2.75 0 0 0-2.936 0 .272.272 0 1 0 .29.458 2.2 2.2 0 0 1 2.355 0c.127.08.294.043.375-.084M10.984 9.849a.194.194 0 1 1 .274-.275.194.194 0 0 1-.274.275m.137-.874a.737.737 0 1 0 .002 1.475.737.737 0 0 0-.002-1.475"
				/>
				<g transform="translate(.26 .43)">
					<mask id="b" fill="#fff">
						<use xlinkHref="#a" />
					</mask>
					<path
						fill="#CD0400"
						d="m21.155 1.152-4.21 8.866-.771-.365 4.21-8.867a.424.424 0 0 1 .569-.202.427.427 0 0 1 .202.568m-4.98 10.316h-1.122l.678-1.425 1.19.566-.408.859zm3.33.543v4.046H2.216v-4.046zM4.424 16.988h12.873V16.6H4.424zm.394-6.38 1.19-.565.677 1.425H5.226zM.584 1.153a.427.427 0 0 1 .77-.366l4.211 8.867-.77.365zM21.186.094a.97.97 0 0 0-1.292.46l-4.212 8.87a.27.27 0 0 0-.325.141l-.904 1.903H7.286l-.904-1.903a.27.27 0 0 0-.325-.142L1.845.553a.969.969 0 1 0-1.751.832l4.213 8.87a.27.27 0 0 0-.096.341l.414.872H1.944a.27.27 0 0 0-.271.272v4.59c0 .15.121.27.271.27h1.937v.66c0 .15.121.271.271.271h13.416c.15 0 .272-.121.272-.271v-.66h1.936c.15 0 .272-.122.272-.272V11.74a.27.27 0 0 0-.272-.272h-2.662l.414-.872a.27.27 0 0 0-.095-.341l4.212-8.87a.97.97 0 0 0-.46-1.291"
						mask="url(#b)"
					/>
				</g>
				<path
					fill="#CD0400"
					d="M7.725 15.278V13.65a.272.272 0 0 0-.543 0v1.628c0 .362.543.362.543 0M6.484 15.278V13.65a.272.272 0 0 0-.543 0v1.628c0 .362.543.362.543 0M5.244 15.278V13.65a.272.272 0 0 0-.543 0v1.628c0 .362.543.362.543 0M13.238 14.735h1.396c.361 0 .361-.543 0-.543h-1.396c-.362 0-.362.543 0 .543M16.189 14.735h1.395c.362 0 .362-.543 0-.543H16.19c-.362 0-.362.543 0 .543"
				/>
				<mask id="d" fill="#fff">
					<use xlinkHref="#c" />
				</mask>
				<path
					fill="#CD0400"
					d="M2.065 16.171h17.53V11.92H2.064z"
					mask="url(#d)"
				/>
				<path
					fill="#FFF"
					d="M7.938 5.134a5.3 5.3 0 0 1 5.844 0 .271.271 0 1 0 .3-.452 5.85 5.85 0 0 0-6.443 0 .272.272 0 1 0 .3.452"
					mask="url(#d)"
				/>
				<path
					fill="#FFF"
					d="M13.057 6.461c.27 0 .374-.35.15-.498a4.29 4.29 0 0 0-4.693 0c-.302.199-.005.653.298.454a3.74 3.74 0 0 1 4.096 0 .27.27 0 0 0 .15.044M12.412 7.615a.27.27 0 0 0-.084-.374 2.75 2.75 0 0 0-2.936 0 .271.271 0 1 0 .291.458 2.2 2.2 0 0 1 2.354 0c.127.08.294.042.375-.084M11.054 9.281a.194.194 0 1 1-.388.001.194.194 0 0 1 .388 0m-.93 0a.736.736 0 1 0 1.472 0 .736.736 0 0 0-1.472 0M.584 1.152a.427.427 0 0 1 .77-.365l4.211 8.866-.77.365zM5.24 11.498l-.422-.89 1.19-.565.802 1.688.49-.233-.918-1.933a.27.27 0 0 0-.325-.142L1.845.553a.969.969 0 1 0-1.751.832l4.213 8.87a.27.27 0 0 0-.096.341l.539 1.135zM16.944 10.019l-.77-.366 4.21-8.867a.424.424 0 0 1 .569-.202.427.427 0 0 1 .202.568zm.045 1.712.54-1.135a.27.27 0 0 0-.096-.341l4.212-8.87a.97.97 0 0 0-1.75-.831l-4.213 8.87a.27.27 0 0 0-.325.141l-.918 1.933.49.233.802-1.688 1.19.566-.422.889z"
					mask="url(#d)"
				/>
				<path
					fill="#FFF"
					d="M19.505 16.057H2.216v-4.046h17.289zm-15.081.932h12.873V16.6H4.424zm15.352-5.52H1.944a.27.27 0 0 0-.271.27v4.59c0 .15.121.272.271.272h1.937v.659c0 .15.121.271.271.271h13.416c.15 0 .272-.121.272-.271v-.66h1.936c.15 0 .272-.121.272-.271v-4.59a.27.27 0 0 0-.272-.27"
					mask="url(#d)"
				/>
				<path
					fill="#FFF"
					d="M7.192 12.95a.27.27 0 0 0-.271.27v1.629c0 .362.543.362.543 0V13.22a.27.27 0 0 0-.272-.272M5.952 12.95a.27.27 0 0 0-.272.27v1.629c0 .362.543.362.543 0V13.22a.27.27 0 0 0-.271-.272M4.711 12.95a.27.27 0 0 0-.271.27v1.629c0 .362.543.362.543 0V13.22a.27.27 0 0 0-.272-.272M14.373 13.763h-1.396c-.362 0-.362.542 0 .542h1.396c.361 0 .361-.542 0-.542M17.323 13.763h-1.395c-.362 0-.362.542 0 .542h1.395c.362 0 .362-.542 0-.542"
					mask="url(#d)"
				/>
			</g>
		</svg>
	);
}
